import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import LinkList, { LinkListItem } from '@tamagoshi/core/LinkList';
import Spacing from '@tamagoshi/core/Spacing';
import { getFooterContext } from '@context';
import { getTranslations } from '@translations';
import { getCurrentYear, computeUrl } from '@utils';
import { usePrevious, useBodyOverflow } from '@hooks';
import { PLATFORMS } from '@constants';
import { CompanyInfo } from './components';
import { aboutLinks, VATNumber } from './constants';

import styles from './styles/index.module.scss';

const More = ({ style }) => {
  const companyInfoRef = useRef(null);
  const { platform, baseUrl } = getFooterContext();
  const translations = getTranslations();
  const { setBodyOverflow, releaseBodyOverflow } = useBodyOverflow();
  const [isVisible, setIsVisible] = useState(false);
  const prevIsVisible = usePrevious(isVisible);
  const onClose = () => {
    setIsVisible(false);
    releaseBodyOverflow();
  };
  const onOpenInfo = event => {
    event.preventDefault();
    setBodyOverflow('hidden');
    setIsVisible(true);
  };

  useEffect(() => {
    if (prevIsVisible && !isVisible && companyInfoRef) {
      companyInfoRef.current.focus();
    }
  }, [isVisible]);

  return (
    <LinkList color="secondary" style={style}>
      {aboutLinks[platform].map(({ id, href, dataQa, ...restProps }) => (
        <Spacing key={id} type="py" size={8}>
          <LinkListItem
            {...restProps}
            key={id}
            href={computeUrl(baseUrl, translations(href))}
            data-qa={dataQa}
            className={styles.moreLinks}
          >
            {translations(id)}
          </LinkListItem>
        </Spacing>
      ))}
      {platform === PLATFORMS.ITALY ? (
        <>
          <Spacing type="py" size={8}>
            <LinkListItem
              ref={companyInfoRef}
              anchorTag="span"
              onClick={onOpenInfo}
              className={styles.companyLink}
            >
              {VATNumber} | {translations('footer.legal.company.information')}
            </LinkListItem>
          </Spacing>
          <CompanyInfo isVisible={isVisible} onClose={onClose} />
        </>
      ) : null}
      <Spacing type="py" size={8}>
        <LinkListItem
          anchorTag="span"
          data-qa="copyrightElm"
          className={styles.moreLinks}
        >
          {`@${getCurrentYear} ManoMano`}
        </LinkListItem>
      </Spacing>
    </LinkList>
  );
};

More.displayName = 'More';

More.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

More.defaultProps = {
  style: {},
};

export default More;
